import { createAction, props } from '@ngrx/store';
import { MgError } from '../../models/error.model';
import { GetEnumRequest } from './enumeration.model';

export enum EnumsActions {
  getEnums = '[Enumeration] getEnums',
  getEnumsSuccess = '[Enumeration] getEnumsSuccess',
  getEnumsFailed = '[Enumeration] getEnums Failed',
}

export const GetEnums = createAction(
  EnumsActions.getEnums,
  props<{ getEnumRequest: GetEnumRequest; endpoint: string }>()
);

export const GetEnumsSuccess = createAction(
  EnumsActions.getEnumsSuccess,
  props<{ getEnumsResponse: {} }>()
);

export const GetEnumsFailed = createAction(
  EnumsActions.getEnumsFailed,
  props<{ error: MgError }>()
);
